import {useEffect, useRef} from 'react';

import {signOutToPortal} from '../../../utils/signOutToPortal';

import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';

export const SignOutPage = () => {

    // FNP-1685: StrictMode runs this effect twice in dev; a second signOut()
    // rejecting after the first started the broker navigation would cancel it.
    const started = useRef(false);

    useEffect(() => {
        if (started.current) {
            return;
        }
        started.current = true;

        const signOutAndRedirect = async () => {
            localStorage.setItem('amplify-signin-with-hostedUI', 'false');
            await signOutToPortal();
        }

        signOutAndRedirect()
    }, []);


    return (
        <Center>
            <PlatformLoader message={'Signing out...Please, wait!'}/>
        </Center>
    );
};
